import React, { memo, useState } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { OcplcKmatLockingQuery, releaseLock } from 'actions/ocplcAction';
import { isPLCAdmin } from 'pages/Utils/OcplcUtil';
import { PLC_WW } from 'constants/ocplcConstants';
import { snackBar } from 'actions/modelActions';
import { LOCAL_STORAGE_KEY, saveToLocalStorage, SELECTED_ROW } from 'utils/localStorageUtil';
import ConfirmationDialog from 'components/ConfirmationDialog';

const OcplcMenuList = memo(({ row, loginUserEmailId, userRole }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [confirmOpen, setConfirmOpen] = useState(false);
    
    const { kmatId, status, productGroup, productLineID ,lastModifiedTS } = row;
    const ocplcAdmin = isPLCAdmin(userRole);
    const isReadOnly = userRole === PLC_WW;
    const authorHasEmail = row?.author?.includes('@');
    const releaseLockdisabled = !isReadOnly && row?.status === "In Progress" && authorHasEmail && (ocplcAdmin || loginUserEmailId === row?.author);

    const handleClick = async (type) => {
        if (!kmatId || !productLineID || !productGroup) {
            dispatch(snackBar(true, `Product Line is empty for KMAT - ${kmatId}`, 'error'));
        } else {
            if (type === 'edit') {
                const isError = await dispatch(OcplcKmatLockingQuery(kmatId, ocplcAdmin, loginUserEmailId, lastModifiedTS, status));
                if (isError) return;
                saveToLocalStorage(LOCAL_STORAGE_KEY, row);
                saveToLocalStorage(SELECTED_ROW, row);
                localStorage.setItem('ocplc_source', 'edit');
                navigate(
                    `/ocplc/${type}`,
                    { state: { source: 'edit' } }
                );
            } else if (type === 'viewRecord') {
                localStorage.setItem('ocplc_source', 'viewRecord');
                saveToLocalStorage(SELECTED_ROW, row);
                navigate(
                    `/ocplc/${type}`,
                    { state: { source: 'viewRecord' } }
                );
            }
        }
    };

    const handleReleaseLock = (kmatId) => {
        dispatch(releaseLock(kmatId));
        setConfirmOpen(false);
    }

    return (
        <Box>
            <Button onClick={() => handleClick('viewRecord')} aria-label="view record" startIcon={<VisibilityIcon />} />
            <Button onClick={() => handleClick('edit')} aria-label="edit" startIcon={<EditIcon />} />
            <Button onClick={() => setConfirmOpen(true)} aria-label="release lock" startIcon={<LockOpenIcon/>} disabled={!releaseLockdisabled}/>
            <ConfirmationDialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                title="Release Lock"
                content={`You are about to release your lock on this Product Family - ${row.kmatId}. Other users will be able to access it. Do you want to continue?`}
                caption="Unlock"
                bgColor="#0096D6"
                onConfirm={() => handleReleaseLock(row.kmatId)}
                secondaryCaption="Cancel"
            />
        </Box>
    );
});

export default OcplcMenuList;